import helpers from '@lib/analytics/amplitude/helpers'

const { sendEvent } = helpers

const clickHelpCenter = (): void => {
  sendEvent('click-help-center', {})
}

export default {
  clickHelpCenter,
}
